import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-sso-login',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.scss'],
})
export class SsoLoginComponent {
  showEror: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
  }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.hasOwnProperty('error') && params['error']) {        
        this.showEror = true; // Show error message in the template
      }
    });
  }


  loginWithSSO() {
    window.location.href = environment.apiUrl + 'oidc/authenticate/';
  }
}
